module.exports = __webpack_public_path__ + "media/job/Spinning-circle-9ba231e8.gif";